import { render, staticRenderFns } from "./DeliverysView.vue?vue&type=template&id=9cd25c20&lang=pug"
import script from "./DeliverysView.vue?vue&type=script&lang=js"
export * from "./DeliverysView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports